/**
 * Environment configuration with validation
 * Validates required environment variables at runtime
 */
interface EnvironmentConfig {
  NODE_ENV: 'development' | 'production' | 'test'
  VITE_API_URL: string
  VITE_WEB_URL: string
  VITE_POSTHOG_KEY?: string
  VITE_POSTHOG_HOST?: string
  VITE_SENTRY_DSN?: string
}

const requiredEnvVars = ['VITE_API_URL'] as const

function validateEnvironment(): EnvironmentConfig {
  const missing = requiredEnvVars.filter((key) => !import.meta.env[key])

  if (missing.length > 0) {
    const error = new Error(
      `Missing required environment variables: ${missing.join(', ')}\n\n` +
        'For local development: Copy .env.example to .env and set your values.'
    )
    console.error('Environment validation failed:', error.message)
    throw error
  }

  return {
    NODE_ENV: import.meta.env.MODE as EnvironmentConfig['NODE_ENV'],
    VITE_API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3011',
    VITE_WEB_URL: import.meta.env.VITE_WEB_URL || 'http://localhost:3001',
    VITE_POSTHOG_KEY: import.meta.env.VITE_POSTHOG_KEY,
    VITE_POSTHOG_HOST: import.meta.env.VITE_POSTHOG_HOST,
    VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  }
}

// Validate environment on module load
export const env = validateEnvironment()
